import { Filter } from '../models';
import { DEFAULT_EXPLOSION_PROTECTION } from './ExplosionProtection';
import { DEFAULT_FREQUENCY } from './Frequency';
import { DEFAULT_LANGUAGE_VALUE } from './Language';
import { DEFAULT_RATED_POWER_BASED_ON_FOR_50 } from './Power';
import { DEFAULT_VOLTAGE_FOR_50 } from './Voltage';

export const INITIAL_FILTER: Filter = {
    frequency: DEFAULT_FREQUENCY,
    voltage: DEFAULT_VOLTAGE_FOR_50,
    efficiencyClass: '',
    speed: null,
    ratedPowerBasedOn: DEFAULT_RATED_POWER_BASED_ON_FOR_50,
    power: null,
    frameMaterial: DEFAULT_LANGUAGE_VALUE,
    motorType: DEFAULT_LANGUAGE_VALUE,
    frameSize: '',
    mlfb: '',
    explosionProtection: DEFAULT_EXPLOSION_PROTECTION
};
